export default __webpack_public_path__ + "static/media/1 (11).16ba9a4f.jpg";